import React from "react";
import docImage from "../asset/images/partner-portal/photo-img.svg";
import deleteImg from "../asset/images/revamp-images/delete.svg";
import eyeIcon from "../asset/images/partner-portal/eye.svg";
import checkCircle from "../asset/images/revamp-images/check_circle.svg";

const DocumentUploader = ({
  label,
  docKey,
  fileState,
  setFile,
  error,
  setError,
  onDelete,
  onPreview,
  documentData,
  handleUpload,
  optional,
}) => {
  const isAvailable = documentData[docKey]?.isAvailable;
  const fileName = documentData[docKey]?.name || fileState?.name;

  return (
    <div className="list-col">
      <div className="form-group pan-input custom-suggest partner-form">
        <div className="pan-data">
          <div className="label-wrapper">
            <label className="doc-name">
              {label}
              {!optional && <span className="mandatory-label">*</span>}
            </label>
            {isAvailable && (
              <label className="green-text">
                Uploaded <img src={checkCircle} alt="check_circle" />
              </label>
            )}
          </div>
          {!isAvailable && <label>Upload self-attested document</label>}
          {isAvailable ? (
            <div className="doc-uploaded">
              <div className="doc-text">
                <div className="check-image">
                  <span className="file-wrap">
                    <img src={docImage} alt="document-pic" />
                    <label className="img-name">{fileName}</label>
                  </span>
                  <div className="wrap-del-preview">
                    <button type="button" onClick={() => onDelete(docKey)} className="del-btn">
                      <img src={deleteImg} alt="delete icon" /> Delete
                    </button>
                    <div className="preview-text">
                      <span 
                      className="icon-text" 
                      type="button" 
                      // onClick={onPreview(documentData[docKey]?.url, documentData[docKey]?.name || fileState?.name)}
                      onClick={() =>
                        onPreview(
                          documentData[docKey]?.url,
                          documentData[docKey]?.name || fileState?.name
                        )
                      }
                      >
                        <img src={eyeIcon} alt="eye icon" /> Preview
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : error ? (
            <div className="image" id="uploadimg">
              <span className="forget-link wrong-format doc-error">{error}</span>
            </div>
          ) : null}
        </div>

        <div className="buttons-partner">
          <input
            type="file"
            id={label.replace(/\s/g, "")}
            accept="image/png, image/jpeg, image/jpg, application/pdf"
            className="pan-form"
            onChange={(e) =>
              handleUpload({
                e,
                type: parseInt(docKey),
                setFile,
                setError,
              })
            }
            key={fileState?.name || ""}
          />
          {isAvailable ? (
            <label className="disable-btn">Choose File</label>
          ) : (
            <label htmlFor={label.replace(/\s/g, "")}>Choose File</label>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentUploader;